// extracted by mini-css-extract-plugin
export default {"tag":"views-CheckoutPage-components-PriceContainer-styles__tag--dws2H"};